import styled from "styled-components";

export const AddButtonWrapper = styled.div`
  display: flex;
  margin-top: 16px;
`;
